<ng-container *transloco="let t;">
    @if (filter?.operator) {
        <span> {{ t(AdvancedFiltersOperatorTranslations[filter.operator]) }}</span>
        @switch (filter.operator) {
            @case (AdvancedFilterOperatorEnum.between) {
                @if (filter?.value?.length > 0) {
                    <span>
                        @if (isDate(filter?.value[0])) {
                            <ng-container *ngTemplateOutlet="dateField; context: {data: filter?.value[0] || ''}"></ng-container>
                        } @else {
                            <ng-container *ngTemplateOutlet="stringField; context:{data: filter?.value[0] || ''}"></ng-container>
                        }

                    </span>
                    @if (filter?.value?.length > 1) {
                        <span>And</span>
                        <span>
                                @if (isDate(filter?.value[0])) {
                                    <ng-container *ngTemplateOutlet="dateField; context: {data: filter?.value[1] || ''}"></ng-container>
                                } @else {
                                    <ng-container *ngTemplateOutlet="stringField; context:{data: filter?.value[1] || ''}"></ng-container>
                                }
                        </span>
                    }
                }
            }
            @default {
                <span><ng-container *ngTemplateOutlet="stringField; context:{data: filter.value}"></ng-container></span>
            }
        }
    }

    @if (filter?.field_type === 'condition') {
        @if (filter.condition_type === 'and') {
            {{ t(AdvancedFiltersOperatorTranslations[AdvancedFilterOperatorEnum.and]) }}
        }
        @if (filter.condition_type === 'or') {
            {{ t(AdvancedFiltersOperatorTranslations[AdvancedFilterOperatorEnum.or]) }}
        }
    }
</ng-container>

<ng-template #dateField let-data="data">
    {{ data | dateFormat:dateFormat }}
</ng-template>
<ng-template #stringField let-data="data">
    {{ data || '' }}
</ng-template>